import { useAuth } from 'react-oidc-context';
import { getProjectRoles } from 'lib/auth/authUtils';

// Zitadel project-role key that unlocks the "My Images" tab (internal STAC
// catalog of purchased high-res imagery). Must match the role name created in
// Zitadel EXACTLY (case-sensitive), and the backend gate require_role("internal").
export const INTERNAL_ROLE = 'internal';

// True when the current user's token carries the `internal` project role.
// Reads the token roles claim (not the single `role` on /api/me), so it's
// correct for users holding multiple roles (e.g. `user` + `internal`).
export const hasInternalRole = () => getProjectRoles().includes(INTERNAL_ROLE);

// Reactive variant — re-evaluates as OIDC auth settles. Unlike the Bhoonidhi
// role, `internal` is ADDITIVE: the normal catalog/tasking experience stays
// untouched and the user just gains the extra "My Images" tab.
//
// Reads roles from the REACTIVE OIDC token (`auth.user.access_token`), NOT the
// in-memory tokenStore that `hasInternalRole()` uses: that store is filled by
// TokenSync one render AFTER auth settles and is non-reactive, so on reload it
// briefly reports "not internal" and — since it never re-renders on the fill —
// sticks there, flashing/leaving the normal (non-internal) product catalog.
export const useIsInternalUser = () => {
  const auth = useAuth();
  return !!auth.isAuthenticated && getProjectRoles(auth.user?.access_token).includes(INTERNAL_ROLE);
};
